import initialiser from '../../utils/initialiser';

const defaultSettings = {
  selector: '.js-concert-card',
  lastPerformanceAttr: 'data-last-performance',
};

class HidePastConcerts {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;

    // Set settings
    this.settings = { ...defaultSettings, ...settings };

    // DOM Elements
    this.concertCardSelector = document.querySelector(this.settings.selector);
    this.lastPerformanceAttr = this.concertCardSelector.getAttribute(settings.lastPerformanceAttr);
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container) return;

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    window.addEventListener('load', () => this.handleHideConcertCard());
  };

  handleHideConcertCard = () => {
    const childrenWithDataLastPerformance = this.concertCardSelector.querySelectorAll('[data-last-performance]');
    const nowTimestamp = Date.now() / 1000;

    // Loop through each selected element and check its data-last-performance attribute
    childrenWithDataLastPerformance.forEach((element) => {
      // Get the timestamp value from the data-last-performance attribute
      const timestamp = parseInt(element.getAttribute('data-last-performance'), 10);
      // Compare the timestamp with the current time
      if (timestamp < nowTimestamp) {
        // If the timestamp is smaller than the current time, hide the whole container
        element.style.display = 'none';
      }
    });
    this.concertCardSelector.classList.add('visible');
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, HidePastConcerts);
